import { render, staticRenderFns } from "./CreateOemCustomer.vue?vue&type=template&id=d2f06de6"
import script from "./CreateOemCustomer.vue?vue&type=script&lang=js"
export * from "./CreateOemCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports